<template lang="pug">
    app-modal(
      :closeOutside="false",
      titulo="Visualizar dados do usuário",
      :width="1000",
      @closeModal="closeModal()",
      :hasFooter="false"
    )
      template(slot="body")
        app-divider(:label="isPessoaJuridica ? 'Pessoa Jurídica' : 'Pessoa Física'")
        app-display.margin-top(
          :label="isPessoaJuridica ? 'Razão Social:' : 'Nome:'",
          :content="usuario.pessoa.nomeRazaoSocial"
        )
        app-display(
          :label="isPessoaJuridica ? 'CNPJ:' : 'CPF:'",
          :content="isPessoaJuridica ? usuario.pessoa.pessoaJuridica.cnpj : usuario.pessoa.pessoaFisica.cpf"
        )
        app-display.extra-margin-bottom(label="E-mail:", :content="usuario.pessoa.email")

        app-display-multiple(
          label="Telefones:",
          :content="usuario.pessoa.telefones.map(telefone => telefone.numero)",
        )
        app-divider.margin-top(label="Endereço")
        .margin-top
          el-row
            el-col(:span="12")
              app-display(label="CEP:", :content="endereco.cep")
            el-col(:span="12")
              app-display(label="Bairro:", :content="endereco.bairro")

          el-row
            el-col(:span="12")
              app-display(label="Logradouro:", :content="endereco.logradouro")
            el-col(:span="12")
              app-display(label="Número:", :content="endereco.semNumero ? 'S/N' : endereco.numero")

          el-row(:class="{ 'extra-margin-bottom': !endereco.complemento }")
            el-col(:span="12")
              app-display(label="Município:", :content="endereco.municipio.nome")
            el-col(:span="12")
              app-display(label="UF:", :content="endereco.municipio.codigoEstado")

        app-display.extra-margin-bottom(v-if="endereco.complemento", label="Complemento:", :content="endereco.complemento")

        app-divider(label="Dados do usuário")
        .margin-top.margin-bottom
          app-display(label="Situação:", :content="situacao")
          app-display(
            :label="usuario.perfis.length > 1 ? 'Perfis:' : 'Perfil:'",
            :content="perfis"
          )
          app-display(v-if="usuario.municipioPrefeitura", label="Prefeitura:", :content="usuario.municipioPrefeitura.nome")

</template>

<script>
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppDisplay from '@/components/AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import AppDivider from '@/components/AppDivider'

export default {
  components: {
    AppModal,
    AppLabel,
    AppDivider,
    AppDisplay,
    AppDisplayMultiple
  },

  props: {
    usuario: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      enderecoIterpa: {
        logradouro: 'ROD. AUGUSTO MONTENEGRO, KM 09',
        numero: null,
        semNumero: true,
        complemento: '',
        bairro: 'PARQUE GUARAJÁ',
        cep: '66821-000',
        municipio: {
          id: 1501402,
          codigoEstado: 'PA'
        }
      }
    }
  },

  methods: {

    closeModal () {
      this.isCamposModal = true
      this.$emit('closeModal')
    }

  },

  computed: {
    isPessoaJuridica () {
      return !!this.usuario.pessoa.pessoaJuridica
    },
    endereco () {
      return this.usuario.pessoa.endereco ? this.usuario.pessoa.endereco : this.enderecoIterpa
    },

    situacao () {
      if (this.usuario.isBloqueado) {
        return 'Bloqueado'
      }
      return this.usuario.ativo ? 'Ativo' : 'Inativo'
    },
    perfis () {
      return this.usuario.perfis.reduce((acm, current, index) => {
        const isLast = index === this.usuario.perfis.length - 1
        return acm + current.nome + (isLast ? '' : ', ')
      }, '')
    }
  }

}
</script>

<style scoped lang="scss">
  .buttons {
    display: flex;
    justify-content: space-between;
  }

  .margin-top {
    margin-top: 10px;
  }

  .margin-right {
    margin-right: 10px;
  }

  .margin {
    margin-top: -10px;
  }

  .footer {
    height: 0px !important;
  }

  .margin-bottom {
    margin-bottom: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppModalVisualizarUsuario.vue